/*****************************
 * environment.js
 * path: '/environment.js' (root of your project)
 ******************************/

import Constants from "expo-constants";

const ENV = {
  dev: {
    // graphqlUrl: "https://drink-time-graphql.herokuapp.com/graphql",
    // websocketUrl: "https://drink-time-websocket.herokuapp.com"
    graphqlUrl: "http://118d64e2.ngrok.io/graphql",
    websocketUrl: "http://eded9192.ngrok.io",
  },
  staging: {
    graphqlUrl: "https://drink-time-graphql.herokuapp.com/graphql",
    websocketUrl: "https://drink-time-websocket.herokuapp.com",
  },
};

const getEnvVars = (env = Constants.manifest.releaseChannel) => {
  // What is __DEV__ ?
  // This variable is set to true when react-native is running in Dev mode.
  // __DEV__ is true when run locally, but false when published.
  if (__DEV__) {
    return ENV.dev;
  } else if (env === "staging") {
    return ENV.staging;
  }
  // TODO prod
  return ENV.staging;
};

export default getEnvVars;
